import { restApi } from '../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../../lib/loopback'

const motoristasRepository = createRepository({
  path: 'motoristas',
  restApi,
  queryTransform: {
    nome: query.ilike('nome'),
    ...paginate
  }
})

motoristasRepository.motoristaKmm = cpf => {
  return restApi.get(`motoristaKmm/${cpf}`)
}

motoristasRepository.findKmmByCPFForSolicitacao = (solicitacaoId, cpf) => {
  return restApi.get(`/motoristaKmm/${solicitacaoId}/${cpf}`)
}

export default motoristasRepository
